export default "__VITE_ASSET__BuW9XiXS__"